import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Dependent } from '../../models/dependent';
import { getCurrentApiDomain } from '../../helpers/helper-functions';
import { PaginationOptions } from '../../models/pagination_options';
import { PaginatedResults } from '../../models/paginated_results_model';
import { BenefitVerificationResult } from '../../interfaces/benefit-verification-result';

@Injectable({
  providedIn: 'root',
})
export class DependentService {
  apiUrl = getCurrentApiDomain('/general');

  constructor(private http: HttpClient) { }

  requestDependentOneTimePassword(data: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<any>(
      this.apiUrl +
      `/dependents/request-one-time-password`,
      data,
      options
    );
  }

  uploadMemberPhoto(dependent: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<Dependent>(
      this.apiUrl + `/dependents/upload-member-photo`,
      dependent,
      options
    );
  }


  verifyMemberPhoto(dependent: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<any>(
      this.apiUrl + `/dependents/verify-member-photo`,
      dependent,
      options
    );
  }



  show(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Dependent>(
      this.apiUrl + `/dependents/${uuid}`,
      options
    );
  }

  findByMemberNumberAndSuffix(memberNumber: string, beneficiaryNumber: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<Dependent>>(
      this.apiUrl +
      `/dependents/find-by-member-number-and-suffix/${memberNumber}/${beneficiaryNumber}`,
      options
    );
  }


  verifyDependentOneTimePassword(data: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<any>(
      this.apiUrl +
      `/dependents/verify-one-time-password`,
      data,
      options
    );
  }


  verifyDependentBenefit(data: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<BenefitVerificationResult>(
      this.apiUrl +
      `/dependents/verification/benefit`,
      data,
      options
    );
  }

  indexByMemberNumber(
    memberNumber: string,
    paginationOptions: PaginationOptions
  ) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
      `/dependents/index-by-member-number/${memberNumber}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }
}
